import { render, staticRenderFns } from "./PayinDetailDownload.vue?vue&type=template&id=be6721e0&scoped=true"
import script from "./PayinDetailDownload.vue?vue&type=script&lang=js"
export * from "./PayinDetailDownload.vue?vue&type=script&lang=js"
import style0 from "./PayinDetailDownload.vue?vue&type=style&index=0&id=be6721e0&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be6721e0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/project/moneypay-web/moneypay-merchant-admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('be6721e0')) {
      api.createRecord('be6721e0', component.options)
    } else {
      api.reload('be6721e0', component.options)
    }
    module.hot.accept("./PayinDetailDownload.vue?vue&type=template&id=be6721e0&scoped=true", function () {
      api.rerender('be6721e0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/ezpay/customer-service/components/PayinDetailDownload.vue"
export default component.exports